import React, { useRef } from 'react';
import classnames from 'classnames';
import './FileUpload.css';
import { Icon } from '../../Icon/Icon';
import { IconName } from '../../Icon/IconName';
import './../input.scss';
import { t } from '../../../locales/translate';
import { FormField } from '../../../model/form';
import { Collapse } from '@nerdgeschoss/shimmer-component-collapse';

interface Props extends FormField<File | null> {
  label?: string;
  error?: boolean;
  description?: string;
  icon?: IconName;
  multiple?: boolean;
  required?: boolean;
  accept?: string;
}

export function FormFileUpload({
  name,
  inputId,
  value,
  label,
  error,
  multiple,
  className,
  description,
  style,
  icon,
  required,
  accept,
  onChange,
  onFocus,
  onBlur,
}: Props): JSX.Element {
  const fileUpload: React.MutableRefObject<HTMLInputElement | null> = useRef(null);

  async function handleOnChange(fileList: FileList): Promise<void> {
    const files = Array.from(fileList);
    if (files.length <= 0) {
      onChange?.(null);
    }
    onChange?.(files[0]);
  }

  return (
    <div className={classnames('file-upload', 'input', { 'input--with-icon': icon }, className)} style={style}>
      {icon && <Icon name={icon} className="input__icon" />}
      <div className="input__container input__container--full">
        <div className="input__input-wrapper">
          {label && (
            <label className="input__label" htmlFor={inputId}>
              {label}
              {!required && ` (${t.general.optional})`}
            </label>
          )}
          {value && (
            <div className="file-upload__wrapper">
              {value.name}
              <div
                className="file-upload__remove-button"
                onClick={() => {
                  onChange?.(null);
                }}
              >
                <Icon name="remove-circle--sm" />
              </div>
            </div>
          )}
          {!value && (
            <div className="file-upload__input">
              <input
                id={inputId}
                name={name}
                type="file"
                ref={fileUpload}
                className="input__input"
                accept={accept}
                onChange={(e) => {
                  if (e.target.files) {
                    handleOnChange(e.target.files);
                  }
                }}
                onFocus={onFocus}
                onBlur={onBlur}
                required={required}
                multiple={multiple}
              />
            </div>
          )}
        </div>
        <div className="input__description-wrapper">
          {description && <div className="input__description">{description}</div>}
          <Collapse open={error ? true : false}>
            <div className="input__error-message">{error}</div>
          </Collapse>
        </div>
      </div>
    </div>
  );
}
